import { ClientConfig, ClientContext, FirstMeaningfulPaintContext, HostingConfig } from './types';

const defaultClientConfig: ClientConfig = {
  yammerAppClientId: '1',
  telemetryClientId: 'YAMMER_WEB',
  gitRevision: 'e12de04df238d0dd57676a4de9437b97257bfdb8',
  batchSizeInBytes: 3500,
  eventReportIntervalInMilliseconds: 10000,
  loadedAt: 1533861184,
  appInstanceId: '1533861184.3871041',
  resource: 'https://www.yammer.com/',
  graphqlHost: 'https://www.yammer.com',
  telemetryHost: 'https://www.yammer.com',
  reportAuthorizationReceiver: 'receiver-auth-token',
  reportAuthorizationFallbacks: ['123'],
  skipResourceTimingReportForExternalJavascript: false,
  shouldLogProtobufEventsToConsole: false,
};

const defaultHostingConfig: HostingConfig = {
  hostingEnvironment: 'dev',
  scriptRevision: 'XXX',
};

type Create = <T>(defaults: T) => (overrides?: Partial<T>) => T;
export const create: Create = (defaults) => (overrides) => ({
  ...defaults,
  ...overrides,
});

export const createMockClientConfig = create<ClientConfig>(defaultClientConfig);
export const createMockHostingConfig = create<HostingConfig>(defaultHostingConfig);

const defaultClientContext: ClientContext = {
  osName: 'Windows',
  deviceType: 'Tablet',
  hostClientType: 'Web',
  hostAppName: 'Teams',
  clientFeedLayout: 'Feed',
};

export const createMockClientContext = create<ClientContext>(defaultClientContext);

const defaultFirstMeaningfulPaintContext: FirstMeaningfulPaintContext = {
  firstMeaningfulPaintReported: true,
};

export const createMockFirstMeaningfulPaintContext = create<FirstMeaningfulPaintContext>(
  defaultFirstMeaningfulPaintContext
);
